import { URLS } from 'constants/urls';
import { useEffect, useRef } from 'react';

const VersionChecker = () => {
  const hasChecked = useRef(false);

  useEffect(() => {
    const clearCookies = () => {
      const cookiesToRemove = ['companies', 'units', 'unitGroups', 'unitSubgroups', 'states', 'cities', 'providers'];

      cookiesToRemove.forEach(name => {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${URLS.cookieDomain}`;
      });
    };

    const clearLocalStorage = () => {
      const keysToRemove = ['react-query-cache', 'query-cache', 'app-cache', 'version-cache', 'authContext'];

      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
      });
    };

    const checkVersion = () => {
      if (hasChecked.current) return;
      hasChecked.current = true;

      const meta = document.querySelector('meta[name="app-version"]');
      const currentVersion = meta?.getAttribute('content');

      const lastKnownVersion = localStorage.getItem('app-version');

      if (currentVersion && lastKnownVersion && currentVersion !== lastKnownVersion) {
        clearLocalStorage();
        clearCookies();

        if (window.queryClient) {
          window.queryClient.clear();
        }

        localStorage.setItem('app-version', currentVersion);

        setTimeout(() => {
          window.location.reload();
        }, 100);
      }

      if (currentVersion) {
        localStorage.setItem('app-version', currentVersion);
      }
    };

    checkVersion();

    const interval = setInterval(checkVersion, 300000); // 5 minutos

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default VersionChecker;
